<login-home-navigation></login-home-navigation>

<!-- HERO -->

<section class="contact-hero">

    <div class="container">

        <span class="contact-badge">
            Contact Get Your Vendor
        </span>

        <h1>
            Let's Build Better Manufacturing Connections
        </h1>

        <p>
            Looking for reliable suppliers, manufacturing partners, or new business opportunities?
            Our team is ready to help.
        </p>

    </div>

</section>

<!-- CONTACT -->

<section class="contact-section">

    <div class="container">

        <div class="row">

            <!-- FORM -->

            <div class="col-lg-7">

                <div class="contact-card">

                    <h2>
                        Tell Us How We Can Help
                    </h2>

                    <p class="form-subtitle">
                        Complete the form and our team will get back to you within one business day.
                    </p>

                    <form name="userForm" novalidate>

                        <div class="row">

                            <div class="col-md-6">

                                <div class="form-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        [(ngModel)]="name"
                                        [ngModelOptions]="{standalone:true}"
                                        placeholder="Your Name">
                                </div>

                            </div>

                            <div class="col-md-6">

                                <div class="form-group">
                                    <input
                                        type="email"
                                        class="form-control"
                                        [(ngModel)]="email"
                                        [ngModelOptions]="{standalone:true}"
                                        placeholder="Email Address">
                                </div>

                            </div>

                        </div>

                        <div class="row">

                            <div class="col-md-6">

                                <div class="form-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        [(ngModel)]="phone"
                                        [ngModelOptions]="{standalone:true}"
                                        placeholder="Mobile Number">
                                </div>

                            </div>

                            <div class="col-md-6">

                                <div class="form-group">

                                    <select
                                        class="form-control"
                                        [(ngModel)]="leadType"
                                        [ngModelOptions]="{standalone:true}">

                                        <option value="">
                                            I am interested in...
                                        </option>

                                        <option>
                                            Finding Suppliers
                                        </option>

                                        <option>
                                            Getting Buyer Leads
                                        </option>

                                        <option>
                                            Partnership Opportunities
                                        </option>

                                        <option>
                                            General Inquiry
                                        </option>

                                    </select>

                                </div>

                            </div>

                        </div>

                        <div class="form-group">

                            <textarea
                                class="form-control"
                                rows="6"
                                [(ngModel)]="message"
                                [ngModelOptions]="{standalone:true}"
                                placeholder="Tell us about your requirement">
                            </textarea>

                        </div>

                        <!-- RECAPTCHA -->

                        <div class="form-group captcha-wrapper">

                            <re-captcha
                                siteKey="6Ld9YPMZAAAAALZ7si32freu_SYFZe8UaZ7Z5NdN"  
                                (resolved)="resolved($event)">
                            </re-captcha>

                        </div>

                        <button
                            type="button"
                            class="btn-send"
                            (click)="sendmessage()">

                            Send Message

                        </button>

                    </form>

                </div>

            </div>

            <!-- CONTACT INFO -->

            <div class="col-lg-5">

                <div class="contact-info-card">

                    <div class="info-icon">
                        <i class="fe fe-mail"></i>
                    </div>

                    <h4>Email Us</h4>

                    <p>
                        <a href="mailto:contact@getyourvendor.com">
                            contact@getyourvendor.com
                        </a>
                    </p>

                </div>

                <div class="contact-info-card">

                    <div class="info-icon">
                        <i class="fe fe-phone"></i>
                    </div>

                    <h4>Sales & Support</h4>

                    <p>
                        +91 9049000765
                    </p>

                </div>

                <div class="contact-info-card">

                    <div class="info-icon">
                        <i class="fe fe-briefcase"></i>
                    </div>

                    <h4>Corporate Sales</h4>

                    <p>
                        +91 9049000715
                    </p>

                </div>

                <div class="contact-info-card">

                    <div class="info-icon">
                        <i class="fe fe-map-pin"></i>
                    </div>

                    <h4>Our Office</h4>

                    <p>
                        INDISOURCING SOLUTIONS PVT LTD.<br>
                        Office 501, Siddharth Towers,<br>
                        Kothrud, Pune - 411038,<br>
                        Maharashtra, India
                    </p>

                </div>

                <div class="contact-social">

                    <a href="https://www.linkedin.com/company/get-your-vendor" target="_blank">
                        <i class="fa fa-linkedin"></i>
                    </a>

                    <a href="https://www.facebook.com/gettyourvendor" target="_blank">
                        <i class="fa fa-facebook"></i>
                    </a>

                    <a href="https://www.instagram.com/getyourvendor/" target="_blank">
                        <i class="fa fa-instagram"></i>
                    </a>

                    <a href="https://www.youtube.com/@getyourvendor" target="_blank">
                        <i class="fa fa-youtube"></i>
                    </a>

                </div>

            </div>

        </div>

    </div>

</section>

<!-- VENDOR CTA -->

<section class="vendor-cta">

    <div class="container">

        <div class="cta-box">

            <h2>
                Are You A Manufacturer Looking For More Business?
            </h2>

            <p>
                Join 16,000+ suppliers on Get Your Vendor and connect with buyers actively searching for manufacturing partners.
            </p>

            <button
                class="cta-btn"
                (click)="signup()">

                Register Your Company

            </button>

        </div>

    </div>

</section>

<login-home-footer></login-home-footer>